import React, { useEffect, useState } from "react";
// import Navbar from '../Sidebar/Navbar';
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import "./ManagerPatient/CustomcssMain.css";
import "../loader.css";

function MnagerMainContent(props) {
  const [PatientList, setPatientList] = useState([]);
  const [Bakval, setBakval] = useState("");
  const mangerId = localStorage.getItem("ManegerId");
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useHistory();

  useEffect(() => {
    LoadPatient();
  }, []);

  const LoadPatient = () => {
    const datavalue = {
      UsId: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetAllPortalNewPatient`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions)
      .then((res) => {
        console.log("portal", res.data[0]?.portal_Id);
        setPatientList(res.data);
        localStorage.setItem("MPortalId", res.data[0]?.portal_Id);
        setIsLoading(false);
      });
  };

  const ShowIntents = (pid, pName, pGender) => {
    // localStorage.setItem('PatQusId', pid);
    // localStorage.setItem('PatName', pName);
    // localStorage.setItem('Backvalue', backval)
    // // setBakval(backval)
    // console.log("the vaue", pid, backval)
    localStorage.setItem("PatQusId", pid);
    localStorage.setItem("PatName", pName);

    localStorage.setItem("PatGender", pGender);

    const datavalue = {
      id: pid,
      key: "Not",
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getIntentsByPid`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      localStorage.setItem("QuestionLength", res.data.length);
      res.data.length > 10
        ? navigate.push("/PtientIntentList")
        : navigate.push("/PtientCusIntentList");
    });
  };

  const EditPatient = (valid) => {
    localStorage.setItem("PatientId", valid);
  };

  return (
    <>
      <div className="page-content-wrapper">
      {isLoading ? (
          <div className="page-content d-flex justify-content-center align-items-center">
          <div className="my-wrapper">
          <div class="spinner center">
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
        </div>
          </div>
        
        </div>
        ) : (
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title">Dashboard</div>
              </div>
              <ol className="breadcrumb page-breadcrumb pull-right">
                <li>
                  <i className="fa fa-home"></i>&nbsp;
                  <a className="parent-item" href="/index">
                    Home
                  </a>
                  &nbsp;<i className="fa fa-angle-right"></i>
                </li>
                <li className="active">Dashboard</li>
              </ol>
            </div>
          </div>

          <div className="state-overview">
            <div className="row dashboard-card-wrapper">
              {PatientList &&
                PatientList.length > 0 &&
                PatientList.map((item) => (
                  <div className="col-xl-4 col-md-6 col-12 mb-4">
                    <Link
                      to="/UpdatePatient"
                      onClick={() => EditPatient(item.id)}
                      className=""
                    >
                      <div className="info-box h-100 bg-blue">
                        <span className="info-box-icon push-bottom">
                          <i className="material-icons">person</i>
                        </span>
                        <div className="info-box-content">
                          <span className="progress-description">
                            {item.patient_Nm}
                          </span>
                          <span
                            className="info-box-text genderfont"
                            style={{ fontSize: "13px" }}
                          >
                            {item.p_Gender}
                          </span>
                          <span className="info-box-number">
                            {item.case_Name}
                          </span>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
        )
      }
      </div>
    </>
  );
}

export default MnagerMainContent;
